/** @jsx jsx */
import React from 'react'
import { jsx } from 'theme-ui'
import { css } from '@emotion/react'
import { get } from 'lodash'

import Card from '../../card'
import { ImageInline, RatioBox } from '../../image'
import Graphic from '../../graphic'
import Paragraph from '../../paragraph'
import VideoWrapper from '../../video-wrapper'

import { floodBgImage } from '../../../styles/css'
import { FlexCols, FlexCol, VStack, HStack } from '../../../styles/els'
import { formatImage, renderHTML, resolveButtons } from '../../../lib/helpers'

import CrossSVG from '../../../styles/icons/cross-light.svg'
import TickSVG from '../../../styles/icons/tick-light.svg'

const PricingDiagram = (props) => {
  const {
    heading,
    image: _image,
    imageType,
    mux,
    parties,
    ...otherProps
  } = props

  const image = formatImage(_image)

  return (
    <VStack space={0}>
      <Paragraph text={heading} tTint={true} onDark={true} align="center" />
      <div>
        <Graphic image={image} imageType={imageType} mux={mux} />
      </div>
      {parties && parties.length > 0 ? (
        <div>
          <div
            sx={{
              maxWidth: '1024px',
              mx: 'auto',
            }}
          >
            {['name', 'about', 'pays'].map((_key, _i) => {
              return (
                <FlexCols key={_i}>
                  {parties.map((_party, _j) => {
                    const _v = get(_party, _key)
                    return (
                      <FlexCol
                        key={_j}
                        base={[1, null, Math.min(parties.length, 4)]}
                      >
                        <div
                          sx={{
                            variant:
                              _i === 0 ? 'text.bold_19' : 'text.regular_19',
                            borderTopStyle: 'solid',
                            borderTopWidth: _i === 0 ? '2px' : '1px',
                            borderTopColor: _i === 0 ? 'light' : 'b2',
                            color: _i === 0 || _key === 'pays' ? 'light' : 'b6',
                            pt: 1,
                            pb: 5,
                          }}
                        >
                          {_key === 'pays' ? (
                            <HStack
                              space={2}
                              sx={{
                                opacity: !_v ? 0.5 : null,
                                verticalAlign: 'center',
                              }}
                            >
                              <RatioBox
                                ratio={1}
                                sx={{
                                  width: '30px',
                                  backgroundImage: `url(${
                                    _v ? TickSVG : CrossSVG
                                  })`,
                                }}
                                css={css`
                                  ${floodBgImage}
                                `}
                              />
                              <div
                                sx={{
                                  paddingTop: '2px',
                                }}
                              >
                                {_v ? `Pays license fee` : `No license fee`}
                              </div>
                            </HStack>
                          ) : _v ? (
                            renderHTML(_v)
                          ) : null}
                        </div>
                      </FlexCol>
                    )
                  })}
                </FlexCols>
              )
            })}
          </div>
        </div>
      ) : null}
    </VStack>
  )
}

export default PricingDiagram
